define(['lib/tentacle/config', 'lib/tentacle/binding', 'lib/tentacle/parser'], function (config, Binding, Parser) {

    var Tentacle = function (controls, filters, context) {
        this.controls = controls || {};
        this.filters = filters || {};
        this.context = context || {};
    };

    _.extend(Tentacle.prototype, {

        config: function (options) {
            _.extend(config, options);
            return this;
        },

        registerControls: function (obj) {
            _.extend(this.controls, obj);
            return this;
        },

        registerFilters: function (obj) {
            _.extend(this.filters, obj);
            return this;
        },

        registerContext: function (obj) {
            _.extend(this.context, obj);
            return this;
        },

        withContext: function (context) {
            return this.clone().registerContext(context);
        },

        withControls: function (controls) {
            return this.clone().registerControls(controls);
        },

        withFilters: function (filters) {
            return this.clone().registerFilters(filters);
        },

        clone: function () {
            return new Tentacle(
                _.clone(this.controls),
                _.clone(this.filters),
                _.clone(this.context)
            );
        },

        parse: function (el) {
            var parser = new Parser(this.controls, this.filters, this.context);
            return new Binding(parser.parse(el));
        },

        // parent controls must be placed before children for proper removing
        create: function (controls) {
            return new Binding(controls);
        }

    });

    return new Tentacle();
});
